export default __webpack_public_path__ + "static/media/Total-Sks-dark.c41c127b.svg";